import React from 'react'
import ReactHtmlParser from 'react-html-parser'

const HTMLComponent = ({ markdown, style }: any) => {
	const text = ReactHtmlParser(markdown)

	return <div>{text}</div>
}

export default HTMLComponent
